import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  useColorModeValue,
} from '@chakra-ui/react';
import { AboutPresentationProps, TeamMember } from '../types';
import TeamMemberPresentation from './TeamMemberPresentation';
import CoreValuesPresentation from './CoreValuesPresentation';
import { SectionAnchor } from '../../../shared/components';

const AboutPresentation: React.FC<AboutPresentationProps> = ({
  id,
  heading,
  description,
  teamMembers,
  coreValues
}) => {
  return (
    <>
      <SectionAnchor id={id} />
      <Box 
        as="section"
        pt={{ base: 4, md: 6 }} pb={{ base: 8, md: 12 }}
        bg="gray.50"
      >
      <Container maxW="container.xl">
        <VStack spacing={16}>
          {/* Company Overview */}
          <VStack spacing={6} textAlign="center" maxW="800px" mx="auto">
            <Heading 
              as="h2" 
              size="xl" 
              bgGradient="linear(to-r, brand.primary.dark, brand.primary.base)"
              bgClip="text"
            >
              {heading}
            </Heading>
            <Text fontSize="lg" color="gray.600">
              {description}
            </Text>
          </VStack>

          {/* Core Values */}
          <CoreValuesPresentation values={coreValues} />

          {/* Team Section */}
          <Box width="full">
            <SectionAnchor id="team" />
            <VStack spacing={8} mb={12} textAlign="center">
              <Heading as="h3" size="lg" color="brand.primary.dark">
                Our Leadership Team
              </Heading>
            </VStack>
            
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} maxW="900px" mx="auto">
              {teamMembers.map((member: TeamMember, index: number) => (
                <TeamMemberPresentation 
                  key={index}
                  member={member}
                />
              ))}
            </SimpleGrid>
          </Box>
        </VStack>
      </Container>
    </Box>
    </>
  );
};

export default AboutPresentation;